export default __webpack_public_path__ + "static/media/044.cc16fc3a.jpg";